<li class="story-container" :class="activeStory ? 'active' : ''">
    <div class="story" :class="activeStory ? 'active' : ''">
        <div class="story__header">
            <progress-line
                    :active-line="activeStory"
                    @onFinish="activeStory && btnsShown.includes('next') ? $emit('onNextSlide') :
                     !btnsShown.includes('next') && activeStory ? $emit('goFirstSlide') : null"
            />
            <avatar
                    :title="titleStory"
                    :src="avatarSrc"
                    :alt="titleStory+' icon'"
            />
        </div>
        <div class="story__desc">
            <div class="story__content"  v-if="texts">
                <p class="story__text" v-html="texts" />
            </div>
            <div v-else-if="loadingSpinner" class="spinner">
                <icon name="spinner" />
            </div>
            <placeholder v-else :amount="2"/>
        </div>
        <div class="story__footer">
            <x-button
                    :loading="buttonLoading"
                    :default-text="followStatus ? 'Unfollow' : 'Follow'"
                    @click="$emit(followStatus ? 'Unfollow' : 'onFollow', id)"
            />

            <pre class="error">{{followError}}</pre>
        </div>
        <div v-if="activeStory">
            <a v-if="btnsShown.includes('prev')" href="#" class="btn btn-prev" @click.prevent="$emit('onPrevSlide')">
                <icon name="arrowSlide" />
            </a>
            <a v-if="btnsShown.includes('next')" href="#" class="btn btn-next" @click.prevent="$emit('onNextSlide')">
                <icon name="arrowSlide" />
            </a>
        </div>
    </div>
</li>
